import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=51d466f1&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=51d466f1&prod&lang=scss&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=51d466f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d466f1",
  null
  
)

export default component.exports